module.exports = __webpack_public_path__ + "img/t2-12.62e8789a.svg";